import { isValidCNPJ, isValidCPF, isValidPhone } from '@brazilian-utils/brazilian-utils';
import { isFieldText } from '~/components/FieldText';
import { FieldType } from '~/shared/domain/models';
import {
  cnpjMessage,
  cpfMessage,
  dateMessage,
  professionalEmailMessage,
  isValidDate,
  isValidProfessionalEmail,
  isValidZipcode,
  phoneMessage,
  zipcodeMessage,
} from '../validations';
import type { FieldSchemas } from './generateCustomValidations';
import type { z } from 'zod';
import type { FieldsDisplayedSchema } from '~/shared/domain/models';

type GenerateByFieldType = (
  schema: FieldSchemas,
  field: FieldsDisplayedSchema,
) =>
  | z.ZodString
  | z.ZodNumber
  | z.ZodEffects<z.ZodString, string, string>
  | z.ZodArray<z.ZodString, 'many'>;

export const generateByFieldType: GenerateByFieldType = ({ stringSchema, numberSchema }, field) => {
  if (isFieldText(field)) {
    switch (field.type) {
      case FieldType.cnpj:
        return stringSchema.refine(isValidCNPJ, { message: cnpjMessage });
      case FieldType.cpf:
        return stringSchema.refine(isValidCPF, { message: cpfMessage });
      case FieldType.currency:
      case FieldType.number:
        return numberSchema;
      case FieldType.date:
        return stringSchema.refine(isValidDate, { message: dateMessage });
      case FieldType.email:
        return stringSchema.email();
      case FieldType.professionalEmail:
        return stringSchema
          .email()
          .refine(isValidProfessionalEmail, { message: professionalEmailMessage });
      case FieldType.tel:
        return stringSchema.refine(isValidPhone, { message: phoneMessage });
      case FieldType.zipcode:
        return stringSchema.refine(isValidZipcode, { message: zipcodeMessage });
      default:
        return stringSchema;
    }
  }
  return stringSchema;
};
